import {
  collection,
  CollectionReference,
  DocumentSnapshot,
  getDocs,
  getDocsFromCache,
  onSnapshot,
  query,
  QueryConstraint,
  Unsubscribe,
  where,
} from 'firebase/firestore'

import { Chat } from 'Types'

import { firestore } from '../firestore'

const buildChats = (docs: DocumentSnapshot[]) => docs.map((doc) => ({ ...doc.data(), id: doc.id }) as Chat)

export const chatsCollection = (): CollectionReference => collection(firestore(), 'chats')

export const getChats = async (...queryConstraints: QueryConstraint[]): Promise<Chat[]> => {
  const chatsQuery = query(chatsCollection(), ...queryConstraints)
  const snapshot = await getDocs(chatsQuery)
  const chats = buildChats(snapshot.docs)
  return chats
}

type OnChats = (chats: Chat[], removedIds: string[]) => void
export const subscribeOnChats = (...options: [...QueryConstraint[], OnChats]): Unsubscribe => {
  const onChats = options.pop() as OnChats
  const queryConstraints = options as QueryConstraint[]
  const chatsQuery = query(chatsCollection(), ...queryConstraints)

  return onSnapshot(chatsQuery, (snapshot) => {
    const process = async () => {
      const newDocs: DocumentSnapshot[] = []
      let removedIds: string[] = []

      snapshot.docChanges().forEach((change) => {
        if (change.type === 'removed') removedIds.push(change.doc.id)
        else newDocs.push(change.doc)
      })

      if (removedIds.length) {
        const persistedChatsQuery = query(chatsCollection(), where('__name__', 'in', removedIds))
        const persistedIds = (await getDocsFromCache(persistedChatsQuery)).docs.map(({ id }) => id)
        removedIds = removedIds.filter((id) => !persistedIds.includes(id))
      }

      const chats = buildChats(newDocs)
      onChats(chats, removedIds)
    }

    void process()
  })
}
